import React, { useContext } from 'react';
import classnames from 'classnames';
import Icon from '@ifit/react-icons/dist/components/icon';
import SETTINGS_ALT_LINE from '@ifit/react-icons/dist/icons/SETTINGS_ALT_LINE';
import './index.scss';
import { withTheme } from '@ifit/themes/withTheme';
import { ThemeContext } from '@ifit/themes/ThemeContext';
import { filtersText } from '../../../../i18n/translations';
import { shark, solidWhite } from '../../../../theme';

interface IDispatchProps {
  toggleFilters: () => void;
}

interface IOwnProps {
  filterCount: number;
  filterOpen: boolean;
  isMobile: boolean;
  filtersOpen: boolean;
}

interface IProps extends IOwnProps, IDispatchProps {}

/* <div className="button-label">{getButtonText(props)}</div> */
const FilterToggle: React.FC<IProps> = props => {
  const { theme } = useContext(ThemeContext);
  const iconColor = {
    LIGHT:
      (!props.isMobile && props.filterOpen) || props.filtersOpen
        ? solidWhite
        : shark,
    DARK:
      (!props.isMobile && props.filterOpen) || props.filtersOpen
        ? shark
        : solidWhite,
    VAULT: props.filterOpen ? solidWhite : shark,
  }[theme];

  return (
    <button
      className={classnames('toggle-filters', {
        'toggle-color': props.isMobile ? props.filtersOpen : props.filterOpen,
      })}
      onClick={props.toggleFilters}
    >
      <Icon icon={SETTINGS_ALT_LINE} size={16} color={iconColor} />
      <div className="filter-text" title={filtersText()}>
        {filtersText()}
        {(!props.filterOpen || props.isMobile) && props.filterCount > 0 && (
          <span>{props.filterCount}</span>
        )}
      </div>
    </button>
  );
};

export default withTheme(FilterToggle);
